import { AccessPointProcessingStep } from "./accessPointProcessingStep";

export interface AccessPointProcessingResult {
  id: number;
  providerNetworkUploadCorrelationId: string;
  accessPointProcessingCorrelationId: string;
  stepType: AccessPointProcessingStep;
  started: string | null;
  completed: string | null;
  count: number;
  percent: number;
  hasResultTable: boolean;
  resultType: AccessPointProcessingStepResultType;
}

export enum AccessPointProcessingStepResultType {
  Info = "Info",
  Passed = "Passed",
  Adjusted = "Adjusted",
  Warning = "Warning",
  Critical = "Critical",
  Running = "Running",
}
